import { FiInfo } from "react-icons/fi"

import { Title, Container, Select } from "components/Form"
import useT from "utils/hooks/useT"
import { FORSKRIFT_STATES } from "state_management/lims/limsForskrifter"

// ForskriftLink — links an Analysis definition to one or more analysis documents (PRD-003
// Area 2 / SPEC-008; renamed from "Method documents" in SPEC-014). The link is stored ON THE
// DOCUMENT (analysisDefinitionIds, many-to-many), not on the definition payload (the deployed AD
// endpoint rejects unknown fields → 422), so this is a multi-select of the available documents;
// the parent (AnalysisConfigurationPage) owns the selected doc-id list and persists it via
// limsForskrifter.setLinksForDefinition after the definition save resolves.
//
// Controlled component, like ReviewSpecification. Below the picker it shows, per selected
// document, its currently effective version (or "no effective version yet") so the admin sees
// which controlled method will surface on this analysis on the plan.
export default function ForskriftLink({ documents, selectedDocIds, onChange }) {
  const { t } = useT("common")

  const collection = (documents || [])
    .map((d) => ({ id: d.id, name: d.name }))
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""))

  const docById = (id) => (documents || []).find((d) => d.id === id)
  const effectiveLabel = (doc) => {
    const effective = doc && doc.versions.find((v) => v.state === FORSKRIFT_STATES.EFFECTIVE)
    return effective
      ? `${t("limsForskriftVersion")} ${effective.versionNumber} — ${t("limsForskriftStatusEffective")}`
      : t("limsForskriftNoEffective")
  }

  return (
    <>
      <div className="LimsConfigBox-fields">
        <Container>
          <Title>{t("limsAnalysisDocDocuments")}</Title>
          <Select
            isMulti
            name={t("limsForskrifter")}
            collection={collection}
            value={selectedDocIds}
            onChange={(values) => onChange(values || [])}
            menuPosition="fixed"
          />
        </Container>
      </div>
      {selectedDocIds.length > 0 && (
        <ul className="ForskriftLink-effective-list">
          {selectedDocIds.map((id) => {
            const doc = docById(id)
            if (!doc) return null
            return (
              <li key={id} className="ForskriftLink-effective-item">
                <span className="ForskriftLink-effective-name">{doc.name}</span>
                <span className="ForskriftLink-effective-version">{effectiveLabel(doc)}</span>
              </li>
            )
          })}
        </ul>
      )}
      {/* R3: the shared info-icon help convention. R6 (#4094): the text now reads from the
          ANALYSIS's side. `limsForskriftLinkedAnalysesHelp` described the relationship from the
          document's side ("the analysis definitions this document governs"), which is backwards
          here — this screen is one analysis picking its documents, not one document claiming its
          analyses. It had no other call site, so it is replaced rather than duplicated. */}
      <p className="LimsConfigBox-help">
        <FiInfo className="LimsConfigBox-help-icon" title={t("limsForskriftGoverningDocsHelp")} />
        <span>{t("limsForskriftGoverningDocsHelp")}</span>
      </p>
    </>
  )
}
